/** Returns the current user's IANA time zone in the format "America/Los_Angeles", e.g. */
export function getUserTimeZoneName(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
